import Seo from '../Seo';
import Layout from './Layout';

export default function LegalLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Layout>
      <Seo />
      <main className='bg-white '>
        <div className='relative mx-auto w-[90%] max-w-7xl pt-10 lg:w-[80%]'>
          <div className='space-y-4 px-8 py-8 lg:px-16'>{children}</div>
        </div>
      </main>
    </Layout>
  );
}
